module.exports = __webpack_public_path__ + "media/images/logo-e339ac2d09b97133f16d20b65d45cdc0.svg";